/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const validateBillingQueryDataSchema = z.object({
	profile: z.string().uuid().nullable().optional(),
})

export type ValidateBillingQueryDataSchema = z.infer<typeof validateBillingQueryDataSchema>
